import { useState, useEffect, useCallback } from "react";
import * as clienteService from "../../../services/ClienteService";

const useDireccionForm = (baseUrl, toast) => {
  const [nuevaDireccion, setNuevaDireccion] = useState("");
  const [nuevoTipoDireccion, setNuevoTipoDireccion] = useState("");
  const [comuna, setComuna] = useState("");
  const [region, setRegion] = useState("");
  const [regiones, setRegiones] = useState([]);
  const [comunas, setComunas] = useState([]);
  const [nuevoDirecciones, setNuevoDirecciones] = useState([]);
  const [indiceEdicionDireccion, setIndiceEdicionDireccion] = useState(null);
  const [idDomicilio, setIdDomicilio] = useState(null);

  const resetFormularioDireccion = useCallback(() => {
    setNuevaDireccion("");
    setNuevoTipoDireccion("");
    setRegion("");
    setComuna("");
    setIndiceEdicionDireccion(null);
  }, []);

  useEffect(() => {
    const publicUrl = process.env.PUBLIC_URL || "";
    fetch(`${publicUrl}/comunas-regiones.json`)
      .then((response) => response.json())
      .then((data) => {
        const regionesFormateadas = data.regiones.map((r) => ({
          label: r.region,
          value: r.region,
        }));
        setRegiones(regionesFormateadas);
      })
      .catch((error) => {
        console.error("Error al cargar las regiones:", error);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "No se pudieron cargar las regiones",
          life: 3000,
        });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (region) {
      const publicUrl = process.env.PUBLIC_URL || "";
      fetch(`${publicUrl}/comunas-regiones.json`)
        .then((response) => response.json())
        .then((data) => {
          const regionSeleccionada = data.regiones.find((r) => r.region === region);
          if (regionSeleccionada) {
            const comunasFormateadas = regionSeleccionada.comunas.map((c) => ({
              label: c,
              value: c,
            }));
            setComunas(comunasFormateadas);
          }
        })
        .catch((error) => {
          console.error("Error al cargar las comunas:", error);
        });
    } else {
      setComunas([]);
    }
  }, [region]);

  const checkFormDireccion = () => {
    const missingFields = [];
    if (!nuevoTipoDireccion) missingFields.push("Tipo Direccion");
    if (!nuevaDireccion) missingFields.push("Direccion");
    if (!region) missingFields.push("Region");
    if (!comuna) missingFields.push("comuna");
    return missingFields;
  };

  const handleAgregarNuevoDireccion = () => {
    const missingFields = checkFormDireccion();
    if (missingFields.length > 0) {
      toast.current?.show({
        severity: "error",
        summary: "Error de Validación",
        detail: "Por favor, complete correctamente los siguientes campos: " + missingFields.join(", "),
        life: 3000,
      });
      return;
    }

    if (
      nuevoDirecciones.some(
        (dir) =>
          dir.direccion.trim().toUpperCase() === nuevaDireccion.trim().toUpperCase() &&
          dir.tipo.trim().toUpperCase() === nuevoTipoDireccion.trim().toUpperCase() &&
          dir.comuna.trim().toUpperCase() === comuna.trim().toUpperCase()
      )
    ) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Esta dirección ya existe",
        life: 3000,
      });
      return;
    }

    const direccion = {
      direccion: nuevaDireccion,
      tipo: nuevoTipoDireccion,
      comuna: comuna,
      region: region,
    };

    setNuevoDirecciones([...nuevoDirecciones, direccion]);
    resetFormularioDireccion();
  };

  const handleEliminarDireccion = (rowIndex) => {
    setNuevoDirecciones(nuevoDirecciones.filter((_, index) => index !== rowIndex));
  };

  const handleDesactivarDomicilio = async (rowIndex) => {
    const domicilio = nuevoDirecciones[rowIndex];
    if (!domicilio || !domicilio.id) {
      toast.current?.show({
        severity: "warn",
        summary: "ID inválido",
        detail: "No se encontró el ID del domicilio a desactivar.",
        life: 3000,
      });
      return;
    }
    try {
      await clienteService.cambiarEstadoDomicilio(baseUrl, domicilio.id, 0);
      setNuevoDirecciones((prev) => prev.filter((_, idx) => idx !== rowIndex));
      toast.current?.show({
        severity: "success",
        summary: "Domicilio Desactivado",
        detail: "El domicilio ha sido desactivado con éxito.",
        life: 3000,
      });
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo desactivar el domicilio. Debe tener al menos un registro activo.",
        life: 3000,
      });
    }
  };

  const handleSeleccionarDireccion = (index) => {
    const dir = nuevoDirecciones[index];
    setIdDomicilio(dir.id);
    setNuevaDireccion(dir.direccion);
    setNuevoTipoDireccion(dir.tipo);
    setRegion(dir.region);
    setComuna(dir.comuna);
    setIndiceEdicionDireccion(index);
  };

  const handleGuardarDireccion = () => {
    const missingFields = checkFormDireccion();
    if (missingFields.length > 0) {
      toast.current?.show({
        severity: "error",
        summary: "Error de Validación",
        detail: "Por favor, complete correctamente los siguientes campos: " + missingFields.join(", "),
        life: 3000,
      });
      return;
    }

    if (
      nuevoDirecciones.some(
        (dir, index) =>
          index !== indiceEdicionDireccion &&
          dir.direccion.trim().toUpperCase() === nuevaDireccion.trim().toUpperCase() &&
          dir.tipo.trim().toUpperCase() === nuevoTipoDireccion.trim().toUpperCase() &&
          dir.comuna.trim().toUpperCase() === comuna.trim().toUpperCase()
      )
    ) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Esta dirección ya existe",
        life: 3000,
      });
      return;
    }

    if (indiceEdicionDireccion !== null) {
      const actualizados = [...nuevoDirecciones];
      actualizados[indiceEdicionDireccion] = {
        id: idDomicilio,
        direccion: nuevaDireccion,
        tipo: nuevoTipoDireccion,
        comuna: comuna,
        region: region,
      };
      setNuevoDirecciones(actualizados);
      setIndiceEdicionDireccion(null);
      resetFormularioDireccion();
    } else {
      handleAgregarNuevoDireccion();
    }
  };

  const setDireccionesIniciales = (direcciones) => {
    if (direcciones) {
      setNuevoDirecciones(direcciones);
    }
  };

  return {
    nuevaDireccion,
    setNuevaDireccion,
    nuevoTipoDireccion,
    setNuevoTipoDireccion,
    comuna,
    setComuna,
    region,
    setRegion,
    regiones,
    comunas,
    nuevoDirecciones,
    setNuevoDirecciones,
    indiceEdicionDireccion,
    handleGuardarDireccion,
    handleEliminarDireccion,
    handleDesactivarDomicilio,
    handleSeleccionarDireccion,
    resetFormularioDireccion,
    setDireccionesIniciales,
  };
};

export default useDireccionForm;
